import asyncSessionLoader from "../../../gd/data/async-session-loader"
import ApiFinder from "../../../gd/api/finder"
import EventsCollection from "../../../model2/event/collection"

const debug = false
// const debug = "finderLoadProjectEvents"

export function finderLoadProjectEvents(parentProjectId: ID, statusId: string): Promise<EventsCollection> {
    debug && console.log(debug, 'process')

    return new Promise(async (resolve, reject) => {
        const response = await ApiFinder.events(parentProjectId, statusId === 'open').promise()

        _.map(response, (item:any)=>item.projectId = parentProjectId)

        await asyncSessionLoader(findMissingData(response))
        const collection:EventsCollection  = EventsCollection.initFromJson(response)

        debug && console.log(debug, 'loadedData', collection)

        resolve(collection)
    })
}

function findMissingData(events: any[]) {
    if (!events) return false
    let uniqueUserIds = _.compact(_.union(_.map(events, 'userId'), _.map(events, 'actionRequiredId')))

    return gd.session.findMissing({
        users: uniqueUserIds
    })
}